var swiperThumbnail = new Swiper(".swiper-thumbnail", {
  loop: true,
  spaceBetween: 4,
  slidesPerView: 7,
  //   freeMode: true,
  watchSlidesProgress: true,

  breakpoints: {
    768: {
      spaceBetween: 7,
      direction: "vertical",
    },
  },
});
var swiperShop = new Swiper(".swiper-shop-img", {
  loop: true,
  spaceBetween: 20,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },

  thumbs: {
    swiper: swiperThumbnail,
  },
});

/// Select the close button
const closePopupButton = document.querySelector(".close-btn");

// Function to open the popup
document
  .querySelector(".video-popup-button")
  .addEventListener("click", function () {
    const popup = document.getElementById("popup");
    popup.style.display = "flex";
    popup.style.zIndex = "10"; // Add z-index when displayed
    document.body.style.overflow = "hidden"; // Disable scrolling

    // Lower z-index for .section-header and .announcement-bar-section
    document.querySelector(".section-header").style.zIndex = "0";
    document.querySelector(".announcement-bar-section").style.zIndex = "0";
    document.querySelector(".sticky-cta-wrapper").style.zIndex = "0";

    // Log to confirm popup opened
    console.log("Popup opened.");
  });

// Event listener for the close button
closePopupButton.addEventListener("click", () => {
  console.log("Close button clicked.");
  closePopup();
});

// Close popup when clicking outside of the popup content
window.addEventListener("click", function (event) {
  const popup = document.getElementById("popup");
  if (event.target === popup) {
    console.log("Clicked outside popup.");
    closePopup();
  }
});

// Function to close the popup, reset styles, and stop the video
function closePopup() {
  const popup = document.getElementById("popup");
  popup.style.display = "none";
  popup.style.zIndex = ""; // Reset z-index when closed
  document.body.style.overflow = ""; // Enable scrolling again

  // Reset z-index for .section-header and .announcement-bar-section
  document.querySelector(".section-header").style.zIndex = "";
  document.querySelector(".announcement-bar-section").style.zIndex = "";
  document.querySelector(".sticky-cta-wrapper").style.zIndex = "";

  // Select the video element within the popup
  const videoElement = popup.querySelector("video");

  // Check if the video element exists and log its status
  if (videoElement) {
    console.log("Video element found. Pausing video.");
    videoElement.pause(); // Pause the video
    videoElement.currentTime = 0; // Optional: Reset video to the start
  } else {
    console.log("No video element found in popup.");
  }

  // Log to confirm popup closed
  console.log("Popup closed.");
}
